<div class="flex flex-col h-full">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="flex items-center gap-2">
            <span class="text-lg font-medium">{{ "workdayEventListDialog.title" | transloco }}</span>
            <button mat-icon-button (click)="openWorkdayGeopisition()" [matTooltip]="'workdayEventListMap.viewWorkdayEventListMap' | transloco">
                <mat-icon class="text-current" [svgIcon]="'feather:map-pin'"></mat-icon>
            </button>
        </div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-1 p-6 sm:p-8 overflow-hidden">
        <div class="flex overflow-auto min-h-0" fuseScrollbar>
            <table class="border-2 table-fixed w-full">
                <tbody>
                @for (workdayEvent of displayWorkdayEventList; track workdayEvent.queueTimestamp) {
                    <tr class="transition-colors">
                        <td class="p-4 border-2 text-left">
                            <div class="flex items-center">
                                @if (workdayEvent.hasGeoposition) {
                                    <button class="-my-2 -ml-2" mat-icon-button (click)="openWorkdayGeopisition(workdayEvent)" [matTooltip]="'workdayEventListMap.viewWorkdayEventListMap' | transloco">
                                        <mat-icon class="text-current" [svgIcon]="'feather:map-pin'"></mat-icon>
                                    </button>
                                }
                                @if (workdayEvent.type === DisplayWorkDayEventType.PAUSE_RESTART) {
                                    {{ pauseReasonNames.get(workdayEvent.pause.pauseReason) }}
                                }  @else if (workdayEvent.type === DisplayWorkDayEventType.PAUSE_WORKDAY) {
                                    {{ "startOf" | transloco }} {{ pauseReasonNames.get(workdayEvent.pauseReason) }}
                                } @else if (workdayEvent.type === DisplayWorkDayEventType.RESTART_WORKDAY) {
                                    {{ "endOf" | transloco }} {{ pauseReasonNames.get(workdayEvent.pauseReason) }}
                                } @else {
                                    {{ workdayEvent.type | transloco}}
                                }
                            </div>
                        </td>
                        <td class="p-4 border-2 text-left w-50">
                            @if (workdayEvent.type === DisplayWorkDayEventType.PAUSE_RESTART) {
                                {{ "fromTime_toTime" | transloco : { fromTime: workdayEvent.pause.formattedTime, toTime: workdayEvent.restart.formattedTime } }} ({{ workdayEvent.difference }} m)
                            } @else {
                                {{ workdayEvent.formattedTime }}
                            }
                        </td>
                    </tr>
                }
                @if (displayWorkdayEventList.length === 0) {
                    <tr>
                        <td colspan="100%" class="py-8 px-4 text-center">
                            {{ "noData" | transloco }}
                        </td>
                    </tr>
                }
                </tbody>
            </table>
        </div>
    </div>
</div>